import { ModuleFE_Tag } from './ModuleFE_Tag.js';
export const ModulePackFE_TagDB = [ModuleFE_Tag];
//# sourceMappingURL=module-pack.js.map